import { z } from 'zod';

export const getCoachTeachingHoursOptionsSchema = z.object({
  coachId: z.string(),
});
export type GetCoachTeachingHoursOptions = z.infer<typeof getCoachTeachingHoursOptionsSchema>;

export const weeklyTeachingHoursWeekSchema = z.object({
  weekStart: z.string(),
  weekEnd: z.string(),
  minutes: z.number(),
  sessions: z.number(),
});
export type WeeklyTeachingHoursWeekDto = z.infer<typeof weeklyTeachingHoursWeekSchema>;

export const coachWeeklyTeachingHoursSchema = z.object({
  weeks: z.array(weeklyTeachingHoursWeekSchema),
});
export type CoachWeeklyTeachingHours = z.infer<typeof coachWeeklyTeachingHoursSchema>;
